/*
  bundlesProduct:
  This JavaScript function initializes an Alpine.js data object for managing the presentation and interaction of bundled products. It integrates sophisticated carousel functionalities and handles product selection dynamically.

  - Parameters:
    - initialProduct: The initial product to display.
    - productType: The type of product, used to fetch related products if specified.

  - Returns:
    - An object containing methods and properties to manage the product bundles, including their display through a carousel and navigation between product options.

  - Key Features:
    - initCarousel: Initializes carousels for main product images and thumbnails using Swiper.
    - initialSetup: Asynchronously fetches product data and sets up the initial product display.
    - updateProduct: Updates the current product display based on user interaction or other triggers.
    - handleOptionChange and updateCurrentVariant: Functions to manage product variant selection based on user input.
    - shopifyData, optionValues, hammockSwatches: Properties that provide structured data about the products for use in the UI.

  This setup allows for a rich, interactive experience in eCommerce environments where bundle offers are prevalent. It helps to enhance user engagement by allowing seamless navigation among bundled product options.

  Registered as an Alpine.js component, it ensures reactivity and dynamic updates as users interact with the product options on the page.
*/


function updateBundleUrl(handle) {
  const currentUrl = new URL(window.location.href);
  const currentHandleInUrl = currentUrl.pathname.split('/').pop();
  if (currentHandleInUrl !== handle) {
    const newUrl = `${currentUrl.origin}/products/${handle}`;
    history.pushState({
      path: newUrl
    }, '', newUrl);
  }
}

function bundlesProduct(initialProduct, productType) {
  return {
    loading: true,
    products: {},
    currentProduct: null,
    currentVariant: null,
    selectedOptions: {},
    mainSwiper: null,

    initCarousel: function() {
      this.$nextTick(() => {
        if (typeof Swiper !== 'undefined') {

          const mainSwiperSelector = '.swiper-container-pdp-gallery';
          const thumbnailsSwiperSelector = '.thumbnails-swiper';

          const mainContainer = document.querySelector(mainSwiperSelector);
          const thumbsContainer = document.querySelector(thumbnailsSwiperSelector);

          if (mainContainer && mainContainer.swiper) {
            mainContainer.swiper.destroy(true, true);
          }
          if (thumbsContainer && thumbsContainer.swiper) {
            thumbsContainer.swiper.destroy(true, true);
          }

          const thumbsSwiper = new Swiper(thumbnailsSwiperSelector, {
            slidesPerView: 'auto',
            freeMode: true,

          });

          this.mainSwiper = new Swiper(mainSwiperSelector, {
            slidesPerView: 'auto',
            loop: false,
            rewind: true,
            pagination: {
              el: '.swiper-pagination-pdp-gallery',
              type: 'progressbar'
            },
            navigation: {
              nextEl: '.swiper-pdp-gallery-next',
              prevEl: '.swiper-pdp-gallery-prev',
            },
            thumbs: {
              swiper: thumbsSwiper,
            }
          });
          mainSwiper.snapGrid.pop();


          console.log('msweer', mainSwiper)

          setTimeout(() => {
            const pdpGallery = document.querySelector('.pdp-product-gallery');
            const pdpThumbnails = document.querySelector('.pdp-product-gallery-thumbnails');
            const galleryWidth = pdpGallery.offsetWidth;
            const isSwipeable = thumbsSwiper.virtualSize > galleryWidth;
            console.log('isswipp', isSwipeable, thumbsSwiper.virtualSize, galleryWidth)
            if (!isSwipeable) {
              pdpGallery.classList.add('centered-thumbnails');
              pdpThumbnails.classList.add('max-content')
            } else {
              pdpGallery.classList.remove('centered-thumbnails');
              pdpThumbnails.classList.remove('max-content')
            }
          }, 100)
        }
      });
      this.$dispatch('swipers-initialized')
    },

    setSlideByImageUrl(imageUrl) {
      if (!this.mainSwiper) {
        console.error('Swiper not initialized');
        return;
      }

      const slideIndex = this.mainSwiper.slides.findIndex((slide) => {
        const img = slide.querySelector('img');
        return img && img.src === imageUrl;
      });

      if (slideIndex !== -1) {
        this.mainSwiper.slideTo(slideIndex, 0);
      } else {
        console.warn('No slide found with the specified image URL');
      }
    },


    get shopifyData() {
      return this.currentProduct;
    },

    initialSetup: async function() {
      let hammockHandles = [initialProduct]
      if (productType) {
        hammockHandles = await fetchHammockHandles(productType);
      }
      await Promise.all(hammockHandles.map(async (handle) => {
        if (!this.products[handle]) {
          try {
            const productData = await fetchProductData(handle);
            this.products[handle] = productData;
            if (productData.bundleHandle) {
              const bundleData = await fetchBundle(productData.bundleHandle);
              this.products[handle].bundleProduct = bundleData;
            } else {
              this.products[handle].bundleProduct = null;
            }
          } catch (error) {
            console.error('Error fetching product data:', error);
          }
        }
      }));

      if (initialProduct && this.products[initialProduct]) {
        this.currentProduct = this.products[initialProduct];
        updateBundleUrl(initialProduct);
        this.initializeSelectedOptions();
        this.initCarousel();
      }
      this.loading = false;
    },

    updateProduct: function(handle) {
      if (this.products[handle]) {
        this.currentProduct = this.products[handle];
        this.initializeSelectedOptions();
        this.$dispatch('current-product-change', {
          product: this.currentProduct
        });
        this.initCarousel();
        updateBundleUrl(handle);
      } else {
        console.error('Product data not found for handle:', handle);
      }
    },

    get optionValues() {
      if (!this.currentProduct || !this.currentProduct.variants) {
        return {};
      }

      const optionValues = {};
      this.currentProduct.variants.forEach(variant => {
        variant.options.forEach(option => {
          if (!optionValues[option.name]) {
            optionValues[option.name] = new Set();
          }
          optionValues[option.name].add(option.value);
        });
      });
      for (const key in optionValues) {
        optionValues[key] = Array.from(optionValues[key]);
      }

      return optionValues;
    },

    get hammockSwatches() {
      let availableProducts = Object.values(this.products)
      availableProducts = availableProducts.filter(product => {
          return product.availableForSale && product.disableSwatch !== 'true'
      })
      return availableProducts.map(product => ({
        handle: product.handle,
        name: product.name,
        swatchImage: product.swatchImage,
        badgeText: product.swatchBadge?.text,
        badgeBg: product.swatchBadge?.bg_color,
        badgeTextColor: product.swatchBadge?.text_color,
      }));
    },

    get currentName() {
      if (this.currentProduct.name.endsWith('Hammock')) {
        return this.currentProduct.name.slice(0, -7).trim();
      }
      return this.currentProduct.name;
    },

    get pageTitle() {
      if (productType) {
        return productType
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      } else {
        return this.currentName
      }
    },

    get badges() {
      return this.currentProduct ? getProductBadges(this.currentProduct) : [];
    },

    initializeSelectedOptions: function() {
      const optionCategory = this.currentProduct.options[0].name;
      this.selectedOptions[optionCategory] = this.currentProduct.variants[0].selectedOptions[0].value;
      this.currentVariant = this.currentProduct.variants[0];
    },

    handleOptionChange: function(optionName, optionValue) {
      this.selectedOptions[optionName] = optionValue;
      this.updateCurrentVariant();
    },

    updateCurrentVariant: function() {
      const optionCategory = this.currentProduct.options[0].name;
      const selectedValue = this.selectedOptions[optionCategory];
      this.currentVariant = this.currentProduct.variants.find(variant =>
        variant.options.some(option => option.name === optionCategory && option.value === selectedValue)
      );
    },

    init: async function() {
      console.log('bundler')
      await this.initialSetup();
      this.loading = false;
    },
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('bundlesProduct', bundlesProduct);
});